import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DEFAULT_CONTENT from '../content/PAGE_CONTENT.json';
import LegalFooter from '../components/LegalFooter';

/**
 * /intake — first-party link used in confirmation emails. Redirects to the
 * owner's secure Jotform intake & consent form once it is configured in the
 * CMS (enrollment.intake_form_url). Shows a holding message until then.
 */
export default function Intake() {
  const c = DEFAULT_CONTENT;
  const [state, setState] = useState('loading');

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/page/resolve?slug=home`);
        const d = await r.json();
        const url = d?.content?.enrollment?.intake_form_url || '';
        if (url.startsWith('https://')) {
          window.location.replace(url);
          return;
        }
      } catch (e) { /* fall through */ }
      setState('pending');
    })();
  }, []);

  return (
    <div style={{ background: 'var(--bg)', color: 'var(--cream)', minHeight: '100vh' }} data-testid="intake-page">
      <section className="band center" style={{ background: 'var(--bg)' }}>
        <div className="wrap narrow">
          <p className="eyebrow">Confidential intake &amp; consent</p>
          <h1 className="display">{state === 'loading' ? 'Opening your secure form…' : 'Your form is on its way.'}</h1>
          {state === 'pending' && (
            <p className="sub" data-testid="intake-pending">
              The secure intake and consent form isn&rsquo;t linked here yet. Karla will email it to you personally.
              Completing it is required before your place can be confirmed or any payment accepted.
            </p>
          )}
          <p className="cta-note" style={{ marginTop: '1.5rem' }}>
            Questions? <a href={`mailto:${c.footer.support_email}`}>{c.footer.support_email}</a>
            {' · '}<Link to="/">Back to the page</Link>
          </p>
        </div>
      </section>
      <LegalFooter footer={c.footer} />
    </div>
  );
}
